export {
  itemSlider,
  itemSearchToggle,
  visibleColorFilter,
  visibleFilterIcon,
  colorsModal,
  stockToEstimate,
  detailToEstimate
};

//商品スライダー
var itemSlider = function(){
  var instance = null;
  var el = '.js-item-slide-wrap';
  var $el =  $(el);
  var slideLength = $(".js-item-slide", el).length;
  var hasOneSlide = slideLength === 1;
  var thumbs = [];

  return{
    setThumbImg: function(){
      thumbs = $('.js-item-slide img').map(function(index){
        return $(this).attr('src');
      });
      return this;
    },
    init: function(){
      if (!$el.length) {
        return false;
      }
      instance = new Swiper(el, {
        init: false,
        effect: 'slide',
        speed: 600,
        slidesPerView: 1,
        loop: true,
        pagination: {
          bulletClass:'item-slide-thumb',
          bulletActiveClass:'item-slide-thumb--active',
          el: '.item-slider-pagination',
          clickable: true,
          renderBullet: function (i, className) {
            return `<div class="${className}">
            <div class="base-item-thumb">
            <div class="base-item-thumb__inner"><img class="base-item-thumb__img" src="${thumbs[i]}"></div>
            </div>
            </div>`;
          }
        },
        navigation: {
          nextEl: '.swiper-button-next.js-mv-next',
          prevEl: '.swiper-button-prev.js-mv-prev',
        }
      });
      instance.on('init', function(){
        if(hasOneSlide){
          instance.destroy();
          $('.swiper-button-next.js-mv-next, .swiper-button-prev.js-mv-prev').hide();
          $('.swiper-pagination').hide();
        }
      });
      instance.init();

      if(hasOneSlide){
        return false;
      }
      instance.on('slideChangeTransitionStart', function(){
        //現在のサムネイル要素が領域外にある場合、要素位置にスクロール
        var $parent = $('.item-slider-pagination');
        var parentWidth = $('.item-slider-pagination').outerWidth();
        var $currentThumb = $('.item-slide-thumb').eq(this.realIndex)
        var currentLeft = $currentThumb.position().left+$parent.scrollLeft();
        var currentRight = currentLeft+$currentThumb.outerWidth();
        var parentLeft = $parent.scrollLeft();
        var parentRight = parentLeft+parentWidth;
        if(currentLeft < parentLeft || currentRight > parentRight){
          $parent.animate({scrollLeft: currentLeft}, 400, 'swing');
        }
      });
    }
  }
};

//商品リストの絞り込み&ソートのSP用UI
var itemSearchToggle = function(){
  var $btn = $('.js-item-srch-tgl');
  var $ui = $('.js-item-srch-ui');
  return {
    onEvt: function(){
      $btn.on('click.srchUi', function(){
        var selectedData = $(this).data('item-srch');
        var visibleUiData = $ui.filter(':visible').data('item-srch');
        var $targetUi = $ui.filter(`[data-item-srch=${selectedData}]`);
        var $icon = $btn.filter(`[data-item-srch=${selectedData}]`).find('.tgl-btn');

        $btn.not(`[data-item-srch=${selectedData}]`).removeClass('is-open');
        $btn.not(`[data-item-srch=${selectedData}]`).find('.tgl-btn').removeClass('is-open');
        $ui.not(`[data-item-srch=${selectedData}]`).hide().removeClass('is-show');
        if($targetUi.is(':visible')){
          $btn.filter(`[data-item-srch=${selectedData}]`).removeClass('is-open');
          $icon.removeClass('is-open');
          $targetUi.stop().slideUp(400, function(){
            $targetUi.removeClass('is-show');
          });
        }else{
          $btn.filter(`[data-item-srch=${selectedData}]`).addClass('is-open');
          $icon.addClass('is-open');
          $targetUi.stop().slideDown(400, function(){
            $targetUi.css({'height': 'auto'}).addClass('is-show');
          });
        }
      });
      return this;
    },
    mediaDisplay: function(){
      $ui.not('.is-show').hide();
    }
  }
};

//商品絞り込み「さらにカラーを絞り込む」の表示/非表示
var visibleColorFilter = function(){
  $('.js-filter-color-select').on('change.visibleFilterTrg', function(){
    if($(this)[0].selectedIndex === 0){
      //「さらにカラーを絞り込む」を隠すとともに、アコーディオン開いていたら閉じる
      $('.js-filter-color-trg').hide().filter('.is-open').trigger('click');
    }else{
      $('.js-filter-color-trg').show();
    }
  }).trigger('change.visibleFilterTrg');
};

//商品絞り込みの見出しチェックアイコンの表示非表示
var visibleFilterIcon = function(){
  var $icon =  $('.js-prod-filtered-icon');
  //カラーのさらに絞り込みは含めない
  var $checkbox = $('.js-prod-filter-ui').find('input[type="checkbox"]').not('.js-child-colors input[type="checkbox"]');
  var $select = $('.js-prod-filter-ui').find('select');
  function selected(){
    var isSelected = false;
    $select.each(function(){
      if(!($(this)[0].selectedIndex === 0)){
        isSelected = true;
        return false;
      }
    });
    return isSelected;
  }
  function toggleIcon(){
    //TODO: valueを見るようにした方がよいか
    if($checkbox.filter(':checked').length === 0 && !selected()){
      $icon.hide();
    }else{
      $icon.show();
    }
  }

  $checkbox.on('change.toggleIcon', toggleIcon).trigger('change.toggleIcon');
  $select.on('change.toggleIcon', toggleIcon).trigger('change.toggleIcon');
};

//カラー展開モーダル 汎用モーダルとは別にしておく
var colorsModal = function(){
  if(!$('.js-modal-colors').length){
    return false;
  }
  var scrPos = 0;
  var currentIndex = 0;
  var $item = $('.js-modal-colors-item');
  var colorsSlideInstance = null;

  var colorsSlider = function(initialSlide){
    var el = '.js-colors-slide';
    var $el =  $(el);
    var slideLength = $(".colors-slide__item", el).length;
    var hasOneSlide = slideLength === 1;
    if (!$el.length) {
      return false;
    }
    colorsSlideInstance = new Swiper(el, {
      effect: 'fade',
      speed: 600,
      initialSlide: initialSlide,
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination.colors-pagination',
        type: 'fraction'
      },
      navigation: {
        nextEl: '.swiper-button-next.js-colors-next',
        prevEl: '.swiper-button-prev.js-colors-prev',
      },
      touchEventsTarget: 'wrapper'
    });
    if(hasOneSlide){
      colorsSlideInstance.destroy();
      $('.swiper-button-next.js-colors-next, .swiper-button-prev.js-colors-prev').hide();
      $('.swiper-pagination.colors-pagination').hide();
    }
  };

  $item.on('click', function(){
    scrPos = $(window).scrollTop();
    var imgSrc = $(this).data('color-img');
    var colorName = $(this).data('color-name');
    currentIndex = $item.index(this);
    $('.js-modal-colors').fadeIn();
    colorsSlider(currentIndex);
    $('body').css({
      'top': -scrPos,
      'height': `calc(100% + ${scrPos}px)`
    }).addClass('is-fixed');
    $('.js-sp-hd-middle').addClass('is-body-fixed');
    return false;
  });
  //閉じる
  $('.js-modal-colors-close, .js-modal-colors').on('click', function(e){
    if($(e.target).closest('.js-modal-colors-close').length || !$(e.target).closest('.js-modal-colors-inner').length){
      var $target = $(this).hasClass('js-modal-colors-close') ? $(this).closest('.js-modal-colors') : $(this);
      $target.fadeOut(function(){
        $('body').css({
          'height': 'auto'
        }).removeClass('is-fixed');
        $('.js-sp-hd-middle').removeClass('is-body-fixed');
        $(window).scrollTop(scrPos);
        colorsSlideInstance.destroy();
      });
    }
  });
};

// 在庫状況画面： 画面下部フローティング「見積もり作成」ボタン 表示/非表示
const stockToEstimate = function(){
  const $bottomElm = $('.js-stock-to-estimate-fixed');
  const $header = $('.js-header');
  const $breadcrumb = $('.js-breadcrumb');
  const $content = $('.js-content-wrap');

  return {
    display: function(){
      if(!$bottomElm.length){
        return false;
      }

      const winBottomPos = $(window).scrollTop() + $(window).outerHeight();
      const contentHeight = $header.outerHeight() + $breadcrumb.outerHeight() + $content.outerHeight();

      // スクロールがコンテンツ最下部 - 固定ボタンの高さ以外はボタンは常に表示
      const reachedPageBottom = contentHeight - $bottomElm.outerHeight() <= winBottomPos;
      $bottomElm.toggleClass('is-show', !reachedPageBottom);
    }
  }
};

// 商品詳細画面： 画面下部フローティング「見積もり作成」ボタン 表示/非表示
const detailToEstimate = function () {
    const bottomElm = $('.js-detail-to-estimate-fixed');
    const itemPriceHd = $('.js-item-price-hd');

    return {
        display: function () {
            if (!bottomElm.length) {
                return false;
            }

            const winTopPos = $(window).scrollTop();
            const itemPriceHdPos = itemPriceHd[0].getBoundingClientRect().top + window.scrollY;

            // スクロールがコンテンツ最下部 - 固定ボタンの高さ以外はボタンは常に表示
            const reachedPageBottom = itemPriceHdPos <= winTopPos;
            bottomElm.toggleClass('is-show', reachedPageBottom);
        }
    }
};